/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Recovery_KickerInputs */

const en_features_recovery_kicker = /** @type {(inputs: Features_Recovery_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After yesterday's legs`)
};

const pl_features_recovery_kicker = /** @type {(inputs: Features_Recovery_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po wczorajszych nogach`)
};

/**
* | output |
* | --- |
* | "After yesterday's legs" |
*
* @param {Features_Recovery_KickerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_recovery_kicker = /** @type {((inputs?: Features_Recovery_KickerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Recovery_KickerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_recovery_kicker(inputs)
	return en_features_recovery_kicker(inputs)
});